import React, { useContext } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { grey40, fontSize14, lineHeight, sans } from "@churchofjesuschrist/eden-style-constants";
import { ValidityStateContext } from "./validityState";
export const InternalUseOnlyLabel = styled.label.withConfig({
  componentId: "sc-8e6q3s-0"
})(["color:", ";font:normal normal normal ", " / ", " ", ";"], grey40, fontSize14, lineHeight, sans);
/**
 * The Label represents a caption for an item in a user interface.
 */

const Label = _ref => {
  let {
    children,
    validityState,
    ...props
  } = _ref;
  const validityStateContext = useContext(ValidityStateContext);
  return /*#__PURE__*/React.createElement(InternalUseOnlyLabel, props, /*#__PURE__*/React.createElement(ValidityStateContext.Provider, {
    value: validityState ? validityState : validityStateContext
  }, children));
};

Label.propTypes = {
  /** The current validity state of the Label */
  validityState: PropTypes.oneOf(["error", "warning", "success", "unknown"]),

  /** Content to render inside the Label Component */
  children: PropTypes.node.isRequired
};
export default Label;